import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { Grid, Typography, MenuItem } from "@mui/material";
import StyledSelect from "./StyledSelect";
import Button from "./Button";
import { useEffect, useState } from "react";

interface TablePaginationProps {
  callback: (offset: number, numberOfItemsPerPage: number) => void
  dataLength: number
}

function TablePagination(props: TablePaginationProps) {
  const { callback, dataLength } = props;
  const [offset, setOffset] = useState(0);
  const [page, setPage] = useState(1);
  const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(5);

  const handleNumberOfItemsPerPageChange = (event: any) => {
    setNumberOfItemsPerPage(event.target.value as number);
  }

  useEffect(() => {
    setOffset((page - 1) * numberOfItemsPerPage);
  }, [page, numberOfItemsPerPage])

  useEffect(() => {
    callback(offset, numberOfItemsPerPage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset, page, numberOfItemsPerPage])

  const firstPage = (offset === 0 ? numberOfItemsPerPage : offset) / numberOfItemsPerPage
  const displayedPages = [firstPage, firstPage + 1, firstPage + 2]
  const lastPage = Math.ceil(Math.max(dataLength, numberOfItemsPerPage) / numberOfItemsPerPage) //assuming only 1000 data entries
  return (
    <Grid container justifyContent={'space-between'} sx={{
      alignItems: 'center',
      padding: { md: '1.5rem 2rem', xs: '1rem' },
      gap: { md: 0, xs: 2 }
    }}>
      <Grid xs={12} md={4} container item alignItems={'center'}>
        <Typography variant="body6">Show</Typography>
        <StyledSelect value={numberOfItemsPerPage} sx={{
          backgroundColor: 'background.secondary',
          color: 'text.primary',
          border: '1px solid',
          borderColor: 'background.border'
        }}
          onChange={(event) => handleNumberOfItemsPerPageChange(event)}>
          <MenuItem key={5} value={5} sx={{
            color: 'text.primary'
          }}>
            <Typography variant="body6">5</Typography>
          </MenuItem>
          <MenuItem key={10} value={10} sx={{
            color: 'text.primary'
          }}>
            <Typography variant="xs">10</Typography>
          </MenuItem>
          <MenuItem key={15} value={15} sx={{
            color: 'text.primary'
          }}>
            <Typography variant="body6">15</Typography>
          </MenuItem>
          <MenuItem key={20} value={20} sx={{
            color: 'text.primary'
          }}>
            <Typography variant="body6">20</Typography>
          </MenuItem>
        </StyledSelect>
        <Typography variant="body6">rows</Typography>
      </Grid>
      <Grid xs={12} md={8} container item alignItems={'center'} justifyContent={'flex-end'} flexWrap={'nowrap'}>
        <Button color="secondary" variant='contained' onClick={() => setPage(1)} sx={{
          padding: '0.75rem',
          minWidth: '2.5rem',
          height: '2.4rem',
          marginLeft: { md: '1rem', xs: '0rem' },
        }}>
          <Typography variant='body6' color='text.primary'>First</Typography>
        </Button>
        <Button color="secondary" variant='contained' sx={{
          padding: '0.75rem',
          minWidth: '2.5rem',
          height: '2.4rem',
          marginLeft: '1rem',
          writingMode: 'vertical-rl'
        }}
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
        >
          <ArrowBack style={{
            fontSize: '1rem'
          }} />
        </Button>
        {
          displayedPages.map((displayedPage, index) => {
            if (displayedPage > lastPage) return null
            return (
              <Button color="secondary" variant='contained' sx={{
                padding: '0.75rem',
                minWidth: '2.5rem',
                height: '2.4rem',
                marginLeft: '1rem'
              }}
                key={index + displayedPage}
                onClick={() => setPage(displayedPage)}
                isSelected={page === displayedPage}
              >
                <Typography variant='body6'>{displayedPage}</Typography>
              </Button>
            )
          })
        }
        <Button color="secondary" variant='contained' sx={{
          padding: '0.75rem',
          minWidth: '2.5rem',
          height: '2.4rem',
          marginLeft: '1rem',
          writingMode: 'vertical-rl'
        }}
          onClick={() => setPage((prev) => Math.min(prev + 1, lastPage))}
        >
          <ArrowForward sx={{
            fontSize: '1rem'
          }} />
        </Button>
        <Button color="secondary" variant='contained' sx={{
          padding: '0.75rem',
          minWidth: '3rem',
          height: '2.4rem',
          marginLeft: '1rem'
        }}
          onClick={() => setPage(lastPage)}
        >
          <Typography variant='body6' color='text.primary'>Last</Typography>
        </Button>
      </Grid>
    </Grid>);
}

export default TablePagination